<template>
 <text :style="`font-size: ${rectWidth / 2 - 1}px`" ref="svg_text" :x="x" :y="y" fill="#FFFFFF">{{ value }}</text>
</template>
<script>
import { ICON_COLORS } from "./constant";
export default {
  name: "PointValue",
  props: {
    index: Number,
    value: String,
    borderRadius: String,
    point: Object,
    rectWidth: String,
    rectHeight: String,
    data: Array,
  },
  data() {
    return {
      ICON_COLORS,
      x: 0,
      y: 0,
      positionX: 0,
    };
  },
  mounted() {
    this.handlerChangeData()
  },
  watch: {
    value: {
        handler() {
            this.handlerChangeData()
        }
    },
    data: {
        handler() {
            this.handlerChangeData()
        }
    },
    rectWidth: {
        handler() {
            this.handlerChangeData()
        }
    },
  },
  methods: {
      handlerChangeData() {
        this.positionX = this.$refs.svg_text.getBBox().width;
        this.x = -this.rectWidth / 2 + (this.value.length > 3 ? 2 : 6) + this.point.x;
        this.y = this.rectHeight / 2 + this.point.y;
      },
  }
};
</script>